import { AffiliationPartnerData } from './../affiliation-partner.model';
import { AccomodationReservation, AccomodationTypeData } from "./../itineray.model";
import { Component, OnInit, Input } from "@angular/core";

@Component({
  selector: "app-itinerary-reservations-accomodation-form",
  templateUrl: "./itinerary-reservations-accomodation-form.component.html",
  styleUrls: ["./itinerary-reservations-accomodation-form.component.css"]
})
export class ItineraryReservationsAccomodationFormComponent implements OnInit {
  constructor() { }

  @Input()
  accomodation: AccomodationReservation;

  @Input()
  accomodationId: number;

  @Input()
  npax: number;

  @Input()
  disabled: boolean;

  accomodationTypesData = AccomodationTypeData.values();

  affiliationPartnerData: AffiliationPartnerData[] = AffiliationPartnerData.values();

  ngOnInit() { }

  setFavoriteProposal($event, proposal) {
    $event.stopPropagation();
    this.accomodation.proposals.forEach(element => {
      if (element === proposal) {
        element.favorite = true;

      } else {
        element.favorite = false;
      }
    });
  }

}
